import ResultCard from "./resultCard";

function Results(props: any) {
  
    return (<>
        <div className="results">
            {props.data.map((product: { id: any; }) => (
                <ResultCard data={product} key={product.id} company={props.company}/>
            ))}
        </div>
        {/*props.end && <><br></br><p  className="results">No more products</p></>*/}
    </>);
}
export default Results;
